import { render, staticRenderFns } from "./ContestSectionComponent.vue?vue&type=template&id=585b9b30"
import script from "./ContestSectionComponent.vue?vue&type=script&lang=js"
export * from "./ContestSectionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports